import React, { useState } from "react";
import { Col, Form, Input, Row, Space, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AlmacenEmpleadoSelect } from "../reusable/AlmacenEmpleadoSelect";
import { FilterBtn, SearchBtn, SearchFormUi } from "../../ui";
import { inventarioInicialStartLoad } from "../../../actions";
const initialValues = { almacen: null, search: null };

export const InventarioInicialTableSearchForm = () => {
  const [form] = Form.useForm();
  const { activeEmpleado } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [moreSearch, setMoreSearch] = useState(false);
  const handleSubmit = (value) => {
    localStorage.setItem("SearhFormTable", JSON.stringify(value));
    dispatch(inventarioInicialStartLoad({ ...value }));
  };
  const handleMoreSearch = () => {
    setMoreSearch(!moreSearch);
    if (!moreSearch) form.setFieldValue("search", null);
  };
  return (
    <SearchFormUi
      name="FormSearchInventarioInicial"
      form={form}
      autoComplete="off"
      initialValues={initialValues}
      handleSubmit={handleSubmit}
    >
      {moreSearch && (
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={16} lg={12} xl={12}>
            <Form.Item name="search" label="Nombre">
              <Input placeholder="Buscar por periodo contable" allowClear />
            </Form.Item>
          </Col>
        </Row>
      )}

      <Row gutter={[8, 8]}>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
          <Form.Item name="almacen" label="Almacén">
            <AlmacenEmpleadoSelect
              empleado={activeEmpleado?.id}
              placeholder="[-TODOS-]"
              allowClear
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={8} md={12} lg={6} xl={6}>
          <Form.Item>
            <Space wrap>
              <SearchBtn htmlType="submit" />
              <Tooltip title="Más filtros">
                <FilterBtn displayText={false} onClick={handleMoreSearch} />
              </Tooltip>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </SearchFormUi>
  );
};
